import { render, staticRenderFns } from "./AlertWarning.vue?vue&type=template&id=7b71a258&scoped=true&"
import script from "./AlertWarning.vue?vue&type=script&lang=js&"
export * from "./AlertWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71a258",
  null
  
)

export default component.exports